



















import { Component, Mixins, Vue } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import FileDropArea from '@/components/common/atoms/FileDropArea.vue'
import TeacherTable from '@/components/admin/organisms/TeacherTable.vue'
import TeacherListApis, { BranchData, TeacherData } from '@/mixins/requests/admin/TeacherListApis.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    TeacherTable,
    FileDropArea,
  },
})
export default class TeacherList extends Mixins(TeacherListApis) {
  private branchData: BranchData | null = null
  private teacherList: TeacherData[] = []

  private get branchId() {
    return this.$route.params['branchId']
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    try {
      this.branchData = await this.getBranch(this.branchId)
      this.loadTeacherList()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 講師一覧表示の更新
   */
  private async loadTeacherList() {
    this.teacherList = await this.searchTeacher(this.branchId)
  }

  /**
   * 講師情報一括出力ボタン処理
   */
  private async onClickExport() {
    Vue.prototype.$loading.start()
    try {
      const exportInfo = await this.exportExcel(this.branchId)
      const fileLink = document.createElement('a')
      fileLink.href = exportInfo.url
      fileLink.download = exportInfo.filename
      fileLink.click()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async onDrop(file: File) {
    // 取込処理
    if (confirm('取込を開始しますがよろしいですか？')) {
      Vue.prototype.$loading.start()
      try {
        await this.importExcel(this.branchId, file)
        alert('取込みが完了しました')
        this.loadTeacherList()
      } catch (e: any) {
        if (e.response.data.status === 400) {
          alert(e.response.data.message.message)
        } else {
          alert('取込中にエラーが発生しました')
        }
      } finally {
        Vue.prototype.$loading.complete()
      }
    }
  }

  /**
   * 講師削除ボタン
   */
  private async onClickDelete(userId: string) {
    if (!confirm('削除しますがよろしいですか？')) return

    Vue.prototype.$loading.start()
    try {
      await this.deleteUser(userId)
      this.loadTeacherList()
      alert('削除が完了しました')
    } catch (e: any) {
      if (e.response.data.status === 400) {
        alert(e.response.data.message)
      } else {
        alert('削除中にエラーが発生しました')
      }
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 新規作成ボタン処理
   */
  private onClickCreate() {
    this.$router.push({
      name: 'AdminTeacherCreate',
      params: { branchId: this.branchId },
    })
  }

  /**
   * 編集ボタン処理
   */
  private onClickEdit(teacherId: string) {
    this.$router.push({
      name: 'AdminTeacherEdit',
      params: { teacherId: teacherId },
    })
  }

  private back() {
    this.$router.push({ name: 'AdminBranchList' })
  }
}
